import { ExperimentObject } from '@contexts/experiment/useExperiment';

type UniversalLoginExperimentKey =
    | 'DONT_SHOW_CAPTCHA_ON_SIGNUP_INIT'
    | 'LOGIN_REDESIGN'
    | 'USE_DEVICE_INTELLIGENCE'
    | 'DEVICE_INTELLIGENCE_PARENT_EXPERIMENT'
    | 'USE_MANGO_PAY_FOR_DEVICE_INTELLIGENCE'
    | 'USE_DEVICE_INTELLIGENCE_FINGERPRINT_B2C'
    | 'USE_DEVICE_INTELLIGENCE_BUREAU_B2C'
    | 'USE_INCOGNIA_FOR_DEVICE_INTELLIGENCE'
    | 'LOGIN_REDESIGN_YCS_APP'
    | 'LOGIN_REDESIGN_YCS'
    | 'LOGIN_REDESIGN_BUTTON_YCS'
    | 'LOGIN_REDESIGN_OPTIN'
    | 'LOGIN_REDESIGN_DICTATOR'
    | 'LOGIN_REDESIGN_WEBSPA'
    | 'REDIRECT_TO_ACCOUNT_DELETION_PAGE'
    | 'HIDE_PASSWORD_FLOW'
    | 'HIDE_PASSWORD_FLOW_DESKTOP'
    | 'ZOOM_FONT_SIZE_FIX'
    | 'SOCIAL_LOGIN_KEYBOARD_A11Y_FIX'
    | 'USE_FORTER_FOR_DEVICE_INTELLIGENCE'
    | 'CUSCO_API_CONFIG_NEWSLETTER_TOGGLE'
    | 'WHATSAPP_BUTTON_POSITION'
    | 'WHATSAPP_NON_IN_POSITION'
    | 'WHATSAPP_MAIN_VIEW_MY'
    | 'WHATSAPP_MAIN_VIEW_ID'
    | 'WHATSAPP_MAIN_VIEW_SG'
    | 'ENABLE_PROFILE_PHONE_NUMBER'
    | 'ENABLE_SOCIAL_CONSENT_PHONE_NUMBER'
    | 'SUBMIT_ON_ENTER'
    | 'NEW_PHONE_NUMBER_ASSOCIATION'
    | 'NEW_PHONE_NUMBER_ASSOCIATION_DICTATOR'
    | 'ENABLE_SKIP_OTP_LOGIN_IF_PASSKEY_EXISTS'
    | 'OTP_LOGIN_REDIRECT_TO_UNIFIED_LOGIN'
    | 'HIDE_ARKOSE_CAPTCHA_NOTIFICATION'
    | 'PAYFLEX_106_BWZP_UI'
    | 'SMS_OTP_LOGIN'
    | 'KAKAO_DUPLICATE_LOGIN_PREVENTION';

export const universalLoginExperiment: ExperimentObject<UniversalLoginExperimentKey> = {
    DONT_SHOW_CAPTCHA_ON_SIGNUP_INIT: {
        expId: 'ACC-1754',
        appIds: ['iosAgoda', 'androidAgoda', 'dictator', 'mspa', 'partnercenter', 'rocketmiles'],
        noContextDefault: false,
    },
    USE_DEVICE_INTELLIGENCE: {
        expId: 'ACC-2579',
        appIds: ['ycs', 'ycsApp'],
        noContextDefault: false,
    },
    DEVICE_INTELLIGENCE_PARENT_EXPERIMENT: {
        expId: 'ACC-3379',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    USE_MANGO_PAY_FOR_DEVICE_INTELLIGENCE: {
        expId: 'ACC-3083',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    USE_DEVICE_INTELLIGENCE_FINGERPRINT_B2C: {
        expId: 'ACC-3084',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    USE_DEVICE_INTELLIGENCE_BUREAU_B2C: {
        expId: 'ACC-3151',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    USE_INCOGNIA_FOR_DEVICE_INTELLIGENCE: {
        expId: 'ACC-3182',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    LOGIN_REDESIGN: {
        expId: 'ACC-2419',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'wallet'],
        noContextDefault: false,
    },
    LOGIN_REDESIGN_DICTATOR: {
        expId: 'ACC-2794',
        appIds: ['dictator'],
        noContextDefault: false,
    },
    LOGIN_REDESIGN_WEBSPA: {
        expId: 'ACC-2863',
        appIds: ['webSpa'],
        noContextDefault: false,
    },
    LOGIN_REDESIGN_YCS_APP: {
        expId: 'ACC-3576',
        appIds: ['ycsApp'],
        noContextDefault: false,
    },
    LOGIN_REDESIGN_YCS: {
        expId: 'ACC-3125',
        appIds: ['ycs'],
        noContextDefault: false,
    },
    LOGIN_REDESIGN_BUTTON_YCS: {
        expId: 'ACC-3618',
        appIds: ['ycs'],
        noContextDefault: false,
    },
    LOGIN_REDESIGN_OPTIN: {
        expId: 'ACC-3128',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dictator', 'dspa'],
        noContextDefault: false,
    },
    REDIRECT_TO_ACCOUNT_DELETION_PAGE: {
        expId: 'ACC-3075',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dictator', 'webSpa'],
        noContextDefault: false,
    },
    HIDE_PASSWORD_FLOW: {
        expId: 'ACC-2910',
        appIds: ['mspa'],
        noContextDefault: false,
    },
    HIDE_PASSWORD_FLOW_DESKTOP: {
        expId: 'ACC-2981',
        appIds: ['dictator', 'dspa'],
        noContextDefault: false,
    },
    ZOOM_FONT_SIZE_FIX: {
        expId: 'AVENGERS-2254',
        appIds: ['mspa', 'iosAgoda', 'androidAgoda', 'wallet'],
        noContextDefault: false,
    },
    SOCIAL_LOGIN_KEYBOARD_A11Y_FIX: {
        expId: 'JESTER-3625',
        appIds: ['mspa', 'dspa'],
        noContextDefault: false,
    },
    USE_FORTER_FOR_DEVICE_INTELLIGENCE: {
        expId: 'ACC-3281',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    //CuscoApiConfigNewsletterToggle
    CUSCO_API_CONFIG_NEWSLETTER_TOGGLE: {
        expId: 'CUSCO-16252',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    WHATSAPP_BUTTON_POSITION: {
        expId: 'ACC-3509',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    WHATSAPP_NON_IN_POSITION: {
        expId: 'ACC-3896',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    WHATSAPP_MAIN_VIEW_MY: {
        expId: 'ACC-4355-MY',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    WHATSAPP_MAIN_VIEW_ID: {
        expId: 'ACC-4355-ID',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    WHATSAPP_MAIN_VIEW_SG: {
        expId: 'ACC-4355-SG',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    ENABLE_PROFILE_PHONE_NUMBER: {
        expId: 'ACC-3595',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    ENABLE_SOCIAL_CONSENT_PHONE_NUMBER: {
        expId: 'ACC-4152',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    SUBMIT_ON_ENTER: {
        expId: 'ACC-3698',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    NEW_PHONE_NUMBER_ASSOCIATION: {
        expId: 'ACC-3730',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    NEW_PHONE_NUMBER_ASSOCIATION_DICTATOR: {
        expId: 'ACC-4036',
        appIds: ['dictator'],
        noContextDefault: false,
    },
    ENABLE_SKIP_OTP_LOGIN_IF_PASSKEY_EXISTS: {
        expId: 'ACC-4352',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    OTP_LOGIN_REDIRECT_TO_UNIFIED_LOGIN: {
        expId: 'ACC-4439',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    HIDE_ARKOSE_CAPTCHA_NOTIFICATION: {
        expId: 'ACC-4169',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    PAYFLEX_106_BWZP_UI: {
        expId: 'PAYFLEX-106-BWZP-UI',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa'],
        noContextDefault: false,
    },
    SMS_OTP_LOGIN: {
        expId: 'CN-5609',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa', 'dspa', 'dictator'],
        noContextDefault: false,
    },
    KAKAO_DUPLICATE_LOGIN_PREVENTION: {
        expId: 'KR-4088',
        appIds: ['iosAgoda', 'androidAgoda', 'mspa'],
        noContextDefault: false,
    },
};
